import React from "react"
import Index from "./Index"
import { contentLayout, modules } from "../config/pages"
import { useUser } from "../contexts/UserContext"
import Forbidden from "./Forbidden"

function PendingExit (){
  const {user} = useUser()
  let view = contentLayout[modules.PendingExitsList]
  if(user.permissions.views.length && !user.permissions.views.join().includes(modules.PendingExitsList.toLowerCase())){
    view = Forbidden
  }
  return(
  <Index content={view} module={modules.PendingExitsList}></Index>
 )
}

export default PendingExit